module.exports = "<header>\r\n    <ng-progress></ng-progress>\r\n    <header-component></header-component>\r\n</header>\r\n<div class=\"container\">\r\n    <router-outlet></router-outlet>\r\n</div>\r\n<footer class=\"footer\">\r\n    <footer-component></footer-component>\r\n</footer>";


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = 104
// module chunks = 0